<template>
  <div class="vhp-product-card-container">
    <div class="vhp-product-card" @click="onClickCard(content)">
      <div v-if="content.thumbnail" class="vhp-product-card-wrap">
        <img
          class="card-image"
          alt="card-image"
          :src="content.thumbnail"
          cover
          @error="replaceImage"
        />
      </div>
      <div v-else class="vhp-product-card-wrap">
        <img
          class="card-image"
          alt="card-image"
          :src="content.image || content.images[0] || ''"
          cover
          @error="replaceImage"
        />
      </div>
    </div>
    <div v-if="!showSimple" class="vhp-product-card-content">
      <div class="vhp-text xsmall bold red" style="margin-left: 1px">
        {{ content.brand }}
      </div>
      <div class="vhp-product-card-content-title" v-html="content.title"></div>
      <div v-if="showPrice">
        <div v-if="content.price && typeof content.price === 'number'" class="vhp-product-card-content-price">
          {{ content.price.toLocaleString() }}<span class="price">원</span>
          <!-- <span class="vat">(VAT 포함)</span> -->
        </div>
        <div v-else class="vhp-product-card-content-price">
          가격문의
        </div>
      </div>
      <div
        class="vhp-product-card-content-tags"
        v-if="content.hashTags && showTags"
      >
        <span
          v-for="tag in content.hashTags.slice(0, 5)"
          :key="'hashtag-' + tag"
          class="tag"
        >
          #{{ tag }}
        </span>
        <span v-if="content.hashTags.length > 5"> .. </span>
      </div>

      <span v-if="showDate" class="vhp-product-card-content-right">
        {{ content.editedDate }}
      </span>
    </div>
    <div v-else>
      <div style="margin: 14px 18px">
        <strong class="vhp-text medium" v-html="content.title"></strong>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    content: {
      type: Object,
      default: () => {
        return null;
      },
    },
    baseUrl: {
      type: String,
      default: "/",
    },
    listUrl: {
      type: String,
      default: "/",
    },
    showTitle: {
      type: Boolean,
      default: false,
    },
    showSimple: {
      type: Boolean,
      default: false,
    },
    showTags: {
      type: Boolean,
      default: false,
    },
    showPrice: {
      type: Boolean,
      default: false,
    },
    showDate: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    onClickCard(content) {
      if (content.isExternalLink) {
        window.open(content.externalUrl);
      } else {
        this.$router.push(
          this.baseUrl + "?id=" + content.id + "&list=" + this.listUrl
        );
      }
    },

    getCategoryImage(category) {
      return "@/assets/image/category/" + category.toLowerCase() + ".svg";
    },

    replaceImage(e) {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");
      const container = document.getElementsByClassName("vhp-card-image")[0];

      canvas.width = container.clientWidth;
      canvas.height = 280;

      ctx.font =
        "32px bold Apple SD Gothic Neo, Pretendard-Regular, NotoSansKR, sans-serif ";
      ctx.textBaseline = "middle";
      ctx.textAlign = "center";
      ctx.fillStyle = "#C4182890";
      ctx.fillRect(0, 0, container.clientWidth, 280);

      ctx.fillStyle = "#C4182830";
      ctx.beginPath();
      ctx.moveTo(container.clientWidth * 0.6, 0);
      ctx.lineTo(container.clientWidth, 0);
      ctx.lineTo(container.clientWidth, 200);
      ctx.fill();

      ctx.fillStyle = "#C4182860";
      ctx.beginPath();
      ctx.moveTo(container.clientWidth * 0.6, 280);
      ctx.lineTo(container.clientWidth, 280);
      ctx.lineTo(container.clientWidth, 140);
      ctx.fill();

      ctx.fillStyle = "#FFFFFF";
      ctx.fillText(this.content.title, container.clientWidth / 2, 140);
      let src = canvas.toDataURL("image/png", 1.0);
      e.target.src = src;
    },
  },
};
</script>

<style lang="scss" scoped src="./vhpProductCard.scss"></style>
